import { render, staticRenderFns } from "./Stepps.vue?vue&type=template&id=3d484638&scoped=true&"
import script from "./Stepps.vue?vue&type=script&lang=ts&"
export * from "./Stepps.vue?vue&type=script&lang=ts&"
import style0 from "./Stepps.vue?vue&type=style&index=0&id=3d484638&lang=scss&scoped=true&"
import style1 from "./Stepps.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d484638",
  null
  
)

export default component.exports